var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoFecapVerde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160 35",
    style: {
      enableBackground: "new 0 0 160 35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#00693C;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146.45,0.26h-0.65h-20.5l-5.38,25.6l-3.75-25.6H97.99L83.68,25.78l-3.14-0.07c-5.23,0-8.43-2.89-7.25-8.57 c1.16-5.43,5.83-8.31,11.26-8.31l4.29,0.02l4.82-8.59h-9.98c-10.61,0-21,5.59-23.35,16.68c-0.81,3.81-0.55,6.93,0.52,9.48H45.15 l0.96-4.8h10.06l1.66-7.95h-9.96l1.05-5.03h13.83l1.86-8.32h-25.7h-1.54H9.46L2.2,34.74h13.23l2.6-12.41H29l1.75-8.02H19.76 l1.17-5.68h14.71l-5.5,26.11h32.65l0.92-4.28c2.93,2.7,7.48,4.22,12.75,4.22h2.21h0.09h12.28l4.98-10.01h11.45l1.3,10.01h9.28h13.22 l2.08-9.92h8.8c6.9,0,13.45-3.7,15.32-12.66C159.45,2.84,151.86,0.26,146.45,0.26 M99.62,17.38l5.68-11.39l1.51,11.39H99.62z  M145.7,12.34c-0.81,3.88-4.12,4.45-7.29,4.45h-3.33l1.8-8.51h3.28C143.36,8.28,146.47,8.72,145.7,12.34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFecapVerde);
export default __webpack_public_path__ + "static/media/logo-fecap-verde.3cd6df37c31608c11db30da5e28bdc12.svg";
export { ForwardRef as ReactComponent };